.channelDetailsGridContainer {
  display: grid;
  grid-template-areas:
    "titleArea settingsArea"
    "statisticsArea settingsArea"
    "statisticsArea metadataArea";
  grid-template-rows: auto; /* Automatic row height */
  grid-template-columns: 3fr 2fr; /* Two columns */
  row-gap: 1rem;
  column-gap: 6rem;
}

.titleArea {
  grid-area: titleArea;
}

.statisticsArea {
  grid-area: statisticsArea;
  height: fit-content;
  padding: 1rem;
  background-color: var(--primary-50);
  border: 1px solid var(--primary-400);
}

.settingsArea {
  grid-area: settingsArea;
  padding: 1rem;
  border: 1px solid black;
}

.metadataArea {
  grid-area: metadataArea;
  padding: 1rem;
  border: 1px solid black;
}
